<template>
  <Modal
    class="project-analysis-text-modal"
    header-tag="h3"
    uid="modal-create-note"
    :ref="modalRef"
    :show="show"
    @close="closeModal"
  >
    <template #header><VisibleText>Add a note to a theme</VisibleText></template>
    <div
      v-if="selection && selection.content && selection.content.length"
      style="margin-bottom: 2rem"
    >
      <VisibleText>Note: </VisibleText>
      <span style="background-color: lightgreen">
        {{ selection.content }}
      </span>
    </div>
    <div v-if="selection && !selection.content" style="margin-bottom: 2rem">
      <VisibleText>Adding row </VisibleText>
      <span style="background-color: pink">
        {{ selection.row_index }}
      </span>
    </div>
    <fieldset style="display: flex; flex-direction: column">
      <VisibleText v-if="sortedThemes.length"> Add this note to an existing theme </VisibleText>
      <div
        style="display: flex; flex-direction: row; margin-bottom: -1rem"
        v-if="sortedThemes.length"
      >
        <SvgIconMeaningful
          class="complete-icon-svg"
          icon="search"
          title="filter below themes"
          style="margin-top: 1rem"
        />
        <input
          id="filter_themes"
          type="text"
          name="Filter themes"
          v-model="themeAdd.filter"
          placeholder="Filter below themes"
        />
      </div>

      <div
        style="
          display: flex;
          flex-direction: column;
          max-height: 15rem;
          overflow-y: auto;
          margin-bottom: 1rem;
          padding: 1rem;
        "
      >
        <div
          v-for="(theme, index) in filteredThemes"
          :key="index"
          style="
            font-weight: 500;
            border: none;
            max-width: 50rem;
            display: flex;
            flex-direction: row;
          "
        >
          <button
            class="ui-rounded-pill__wrapper"
            style="font-weight: 500; border: none; display: flex; flex-direction: row"
            :style="{
              'background-color': activeColor(theme.theme_color, index),
            }"
            @click="addThemeToRow(index)"
          >
            <VisibleText style="display: flex; width: 80%; margin-right: 1.5rem">{{
              theme.name
            }}</VisibleText>
            <SvgIconDecorative icon="add" style="display: flex; width: 20%" />
          </button>
          <SvgIconDecorative
            v-if="noteSelectTheme == index"
            icon="check"
            style="display: flex; margin-top: 0.5rem"
          />
        </div>
      </div>

      <label
        for="create-theme-from-row"
        v-if="sortedThemes.length"
        style="width: 80%; padding-left: 1rem"
      >
        <VisibleText> Or create a new theme </VisibleText>
      </label>
      <label for="create-theme-from-row" v-if="!sortedThemes.length">
        <VisibleText> Create a theme you think matches this text </VisibleText>
      </label>
      <div
        style="
          display: flex;
          flex-direction: row;
          margin-bottom: -0.5rem;
          width: 80%;
          padding-left: 1rem;
        "
      >
        <SvgIconMeaningful
          class="complete-icon-svg"
          icon="add"
          title="Add new theme"
          style="margin-top: 1rem"
          v-if="!themeAdd.themeName.length"
        />
        <input
          id="create-theme-from-row"
          type="text"
          name="New theme name"
          v-model="themeAdd.themeName"
          placeholder="New theme name"
        />
      </div>
      <div
        v-if="
          themeAdd.themeName.length &&
          sortedThemes
            .map((theme) => theme.name.toLowerCase())
            .includes(themeAdd.themeName.toLowerCase())
        "
        style="padding-left: 1rem; padding-bottom: 1rem; color: var(--warning-text-colour)"
      >
        <VisibleText>Theme name already exists</VisibleText>
      </div>
    </fieldset>

    <fieldset style="display: flex; flex-direction: column">
      <label style="display: flex" class="create-note__label" :for="`create-note-${id}`">
        <VisibleText>To add text or commentary to your note, enter it below</VisibleText>
      </label>
      <textarea
        :id="`create-note-${id}`"
        class="create-note__textarea"
        style="width: 80%; display: flex"
        v-model="noteText"
      >
      </textarea>
    </fieldset>

    <template #footer>
      <button
        class="create-note__save-btn btn-default"
        type="button"
        @click.prevent="chooseSave"
        :disabled="!isSaveBtnEnabled || this.propReadOnly"
      >
        <VisibleText>Create note</VisibleText>
      </button>
      <button class="btn-cancel" type="button" @click="closeModal">
        <VisibleText>Close</VisibleText>
      </button>
      <span class="create-note__hint" v-show="isHintVisible">
        <SvgIconDecorative icon="info" />
        <VisibleText>All fields required.</VisibleText>
      </span>
    </template>
  </Modal>
</template>

<script>
// Components
import Modal from '@/components/UI/Modal.vue';
import SvgIconDecorative from '@/components/UI/Svg/SvgIconDecorative.vue';
import SvgIconMeaningful from '@/components/UI/Svg/SvgIconMeaningful.vue';

// Mixins
import textAnalysisMixin from '../../Mixins/textAnalysisMixin.js';
import themeListMixin from '../Mixins/themeListMixin.js';
import themeColorsMixin from '../../Mixins/themeColorsMixin.js';

export default {
  name: 'CreateNote',
  mixins: [textAnalysisMixin, themeListMixin, themeColorsMixin],
  components: {
    Modal,
    SvgIconDecorative,
    SvgIconMeaningful,
  },
  props: {
    show: {
      default: () => false,
      type: Boolean,
    },
    selection: {
      type: Object,
      required: false,
      default: () => {},
    },
    textAnalysisObject: {
      type: Object,
      required: false,
      default: () => {},
    },
    allResponses: {
      default: () => [],
      type: Array,
    },
    sortedThemes: {
      type: Array,
      default: () => [],
    },
    propReadOnly: {
      default: () => false,
      type: Boolean,
    },
  },
  data() {
    return {
      updateKey: Date.now(),
      noteText: '',
      noteSelectTheme: -1,
      id: this.$pigeonline.createUUID(),
      showNewTheme: false,
      themeAdd: {
        isExpanded: false,
        themeName: '',
        filter: '',
      },
    };
  },
  created() {
    if (this.sortedThemes.length) {
      this.themeList = this.deepCloneObj(this.sortedThemes);
    }
  },
  computed: {
    text: function () {
      if (!this.selection) {
        return '';
      }
      return JSON.stringify(this.selection);
    },
    isSaveBtnEnabled: function () {
      return (
        (this.noteSelectTheme > -1 ||
          (this.themeAdd.themeName.length > 0 &&
            !this.sortedThemes
              .map((theme) => theme.name.toLowerCase())
              .includes(this.themeAdd.themeName.toLowerCase()))) &&
        !this.textAnalysisObject.showSpinner
      );
    },
    isHintVisible: function () {
      return this.noteText.trim() === '' && this.noteSelectTheme == -1;
    },
    UUIDofTheme: function () {
      let theme = '';
      if (this.noteSelectTheme > -1) {
        theme = this.filteredThemes[this.noteSelectTheme]._id;
      }
      return theme;
    },
    filteredThemes() {
      let list_of_themes = this.deepCloneObj(this.sortedThemes);
      if (this.themeAdd.filter) {
        list_of_themes = list_of_themes.filter((theme) =>
          theme.name.toLowerCase().includes(this.themeAdd.filter.toLowerCase()),
        );
      }
      return list_of_themes;
    },
  },
  methods: {
    refreshThemesFromParent() {
      this.themeList = this.deepCloneObj(this.sortedThemes);
    },
    // This gets called by this component's use of textAnalysisMixin after running ProcessSave
    updateTextObject(cleanedProject) {
      let object = {
        project: cleanedProject,
        scroll: 'main',
      };
      this.$emit('updateTextObject', object);
    },
    addThemeToRow(index) {
      if (this.noteSelectTheme == -1) {
        this.noteSelectTheme = index;
      } else {
        if (this.noteSelectTheme == index) {
          this.noteSelectTheme = -1;
        } else {
          this.noteSelectTheme = index;
        }
      }
    },
    async chooseSave() {
      if (this.themeAdd.themeName.length > 0) {
        await this.saveNewTheme();
      } else if (this.noteSelectTheme > -1) {
        await this.save();
      }
      this.themeAdd.filter = '';
    },
    activeColor(color, index) {
      let newColor = color;
      if (this.noteSelectTheme > -1 && this.noteSelectTheme != index) {
        newColor = 'grey';
      }
      if (this.themeAdd.themeName.length > 0) {
        newColor = 'grey';
      }
      return newColor;
    },
    async save() {
      this.setShowSpinner(true);

      if (!this.UUIDofTheme) return;

      const themeId = this.UUIDofTheme;

      // Build the note object exactly as before
      const note = {
        ...this.selection,
        text: this.noteText,
      };

      // Emit a minimal patch upward
      this.$emit('updateTheme', {
        _id: themeId,
        notes_to_add: [note],
      });

      // Close modal, clear UI, etc.
      this.setShowSpinner(false);
      this.closeModal();
    },

    async saveNewTheme() {
      if (!this.themeAdd.themeName.length) return;

      // 1. Create the theme with the initial note
      const newTheme = await this.createTheme(
        this.themeAdd.themeName,
        [], // no initial keywords
        {
          ...this.selection,
          text: this.noteText,
        },
      );
      if (newTheme) {
        this.$emit('refreshTheme', newTheme._id);

        // 2. Insert into local list
        this.themeList.unshift(newTheme);

        // 3. Trigger async coverage for the new theme
        this.$emit('updateTheme', {
          _id: newTheme._id,
          notes_to_add: [
            {
              ...this.selection,
              text: this.noteText,
            },
          ],
        });
      }

      // 4. Reset UI
      this.themeAdd.themeName = '';
      this.showNewTheme = false;
      this.closeModal();
    },

    closeModal() {
      this.themeAdd.themeName = '';
      this.showNewTheme = false;
      this.noteSelectTheme = -1;
      this.noteText = '';
      this.$emit('closeModal');
    },
  },
};
</script>
